const usePermissionConfig = () => {
  return {
    // 新增配置
    XZPZ: 'OPS-XXZX-PZGL-XZPZ',
    // 编辑配置
    BJPZ: 'OPS-XXZX-PZGL-BJPZ',
    // 停用|启用
    TYQY: 'OPS-XXZX-PZGL-TYQY',
    // 配置详情
    PZXQ: 'OPS-XXZX-PZGL-PZXQ',
    // 导入配置
    DRPZ: 'OPS-XXZX-PZGL-DRPZ',
    // 导出配置
    DCPZ: 'OPS-XXZX-PZGL-DCPZ',
  };
};

export default usePermissionConfig;
